import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";
import { Router } from "@angular/router";
import { Global } from "../classes/Global";
import { StorageHelper } from '../helpers/StorageHelper';
import { StringHelper } from '../helpers/StringHelper';
import { ThemeService } from '../theme.service';

@Component({
  selector: 'app-single-carousel',
  templateUrl: './single-carousel.component.html',
  styleUrls: ['./single-carousel.component.scss']
})
export class SingleCarouselComponent extends BaseComponent implements OnInit {

  /**
   * items must be an object with keys which are categories (here, the different medias: albums, movies,etc),
   * which contain the ojects (concrete movies, albums, etc.)
   */
  @Input() title: string;
  @Input() items;
  @ViewChild("carouselCategoryDiv", {static: false}) carouselCategoryDiv: ElementRef;
  @Output() onWishlistClick = new EventEmitter();
  @Output() onOwnlistClick = new EventEmitter();
  @Output() onBlocklistClick = new EventEmitter();
  categories: Array<any> = [];
  carouselMarginLeft = 0;
  carouselPosition = 0;
  showMoreDiv = true;
  moreOffersURL = "";
  itemCount: number;
  position: number = 0;

  constructor(
    private router: Router,
    private themeService: ThemeService
  ) {
    super();
  }

  ngOnInit() {
    this.categories = Object.keys(this.items);
    let mediaType = this.categories[this.carouselPosition];
    if (mediaType == "movies") {
      mediaType = "buymovies";
    }
    this.moreOffersURL = this.getMoreOffersUrl();
    StorageHelper.getInstance().save(StorageHelper.keys.mediaType, mediaType);
    let it = this.items[this.categories[0]];
    this.itemCount = it? it.length : 0;
  }

  slide(steps: number){

    //hide mode-div for an instant, to let time to the carousel to scroll
    this.showMoreDiv = false;
    //show it after it has finished scrolling. 700ms are set in the css animation
    const slideTimeout = setTimeout(() => {
      this.showMoreDiv = true;
    }, 800);

    //calculate new Carousel position
    this.carouselPosition += steps;
    const m = Object.keys(this.items).length;
    this.carouselPosition = ((this.carouselPosition % m) + m) % m;

    //Apply the margin-left accordingly
    this.carouselMarginLeft = (-this.carouselPosition * this.carouselCategoryDiv.nativeElement.offsetWidth);

  }

  addToWishlist(item) {
    this.onWishlistClick.emit(item);
  }

  addToOwnlist(item) {
    this.onOwnlistClick.emit(item);
  }

  addToBlocklist(item) {
    this.onBlocklistClick.emit(item);
  }

  containsCategory(category: string): boolean {
    return this.categories.indexOf(category) > -1;
  }

  getMoreOffersUrl(): string {
    let mediaType = this.categories[this.carouselPosition];
    return "/" + Global.getCountry() + "/" + this.title + "/" + this.getString(mediaType + 'Url') + "/" + this.getString('onSaleUrl');
  }

  moveRight() {

    const carouselContent: any = document.getElementsByClassName('carousel-content')[0];
    const width = carouselContent.offsetWidth;

    document.getElementsByClassName('category')[0].scrollBy({
      top: 0,
      left: width,
      behavior: 'smooth'
    });
    if(this.position < this.itemCount - 1) {
      this.position++;
    }
  }

  moveLeft() {

    const carouselContent: any = document.getElementsByClassName('carousel-content')[0];
    const width = carouselContent.offsetWidth;
    let category = document.getElementsByClassName('category')[0];
    if(category.scrollBy) {
      category.scrollBy({
        top: 0,
        left: -width,
        behavior: 'smooth'
      });
      if(this.position > 0) {
        this.position--;
      }
    }
    
  }

}

